import React from "react"
import { Link } from "react-router-dom"
import { BackgroundImage } from "@ciq/shared/components/background"
import Logo from "@ciq/shared/components/logo"

/**
 * Displays a 404 Not Found page with a link back to the home page.
 * Uses the same visual structure as ErrorMessage for consistent styling.
 *
 * @returns {React.ReactElement} The 404 page component
 */
export function NotFoundPage() {
  return (
    <div className="login-redirect">
      <BackgroundImage />
      <div className="login-redirect-container">
        <Logo />
        <div className="da-card">
          <h1>Page Not Found</h1>
          <div>
            <span>The page you&apos;re looking for doesn&apos;t exist.</span>
          </div>
          <Link to="/">Go to Home</Link>
        </div>
      </div>
    </div>
  )
}
